var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_19",
    "data-name": "Grupo 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.557,
    height: 58.378,
    viewBox: "0 0 46.557 58.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M0-57.45H46.557v-58.378H0Z",
    transform: "translate(0 115.828)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(1.008 1.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M-2.089-9.041a27.174,27.174,0,0,1,18.547-9.14,27.112,27.112,0,0,1,19.925,7.309M-3.867,1.874C-2.661-.12,4.4-11.4,16.389-12.409,28.795-13.454,36.879-2.757,38.182-.981M-3.426,9.443a26.254,26.254,0,0,0,4.39-4.1c2.254-2.651,2.55-4.1,4.039-6a17.5,17.5,0,0,1,9.3-5.827A17.9,17.9,0,0,1,27.74-4.048,16.918,16.918,0,0,1,35.019,9.183c.083,4.9-2.543,6.879-1.5,11.394a13.128,13.128,0,0,0,4.135,6.612M-3.6,17.62A32.4,32.4,0,0,0,4.211,9.962c2.853-3.989,3.108-6.407,6.32-8.7a12.342,12.342,0,0,1,7.637-2.4,12.167,12.167,0,0,1,9.38,5.28c4.266,6.653-2.5,13.819,1.668,21.75a14.885,14.885,0,0,0,5.176,5.464m-38.6-5.991A48.158,48.158,0,0,0,10.007,11.875C12.019,8.9,13.763,5.447,17.113,5A6.612,6.612,0,0,1,23.6,8.309c.9,1.831.551,4.16-1.5,7.917-4.3,7.9-11.841,14.25-18.251,18.622M-2.02,31.363A70.983,70.983,0,0,0,11.5,19.792a70.271,70.271,0,0,0,6.672-8.641M38.182,2.92a25.26,25.26,0,0,1,.793,18.354M22.819,23.535a9.666,9.666,0,0,0-.441,6.264,9.992,9.992,0,0,0,4.914,6m-17.9.867a16.766,16.766,0,0,1,3.074-2.438c1.654-1.018,2.757-1.722,3.949-1.564,1.826.239,3.343,2.514,3.949,5.465",
    transform: "translate(4.212 18.229)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuella);
export default __webpack_public_path__ + "static/media/Huella.78456706c4cd4808f57caa3acc3abbc4.svg";
export { ForwardRef as ReactComponent };